import { SET_LOCALE_SUCCESS } from '../constants';

export default function intl(state = null, action) {
  if (state === null) {
    return {
      initialNow: Date.now(),
    };
  }

  switch (action.type) {
    case SET_LOCALE_SUCCESS: {
      const { locale, langDir, messages } = action.payload;
      return {
        ...state,
        locale,
        langDir,
        newLocale: null,
        messages: {
          ...state.messages,
          [locale]: messages,
        },
      };
    }

    default: {
      return state;
    }
  }
}
